import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Letter } from './components/Letter';
import { SevenDays } from './components/SevenDays';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { Method } from './components/Method';
import { Pricing } from './components/Pricing';
import { Imagine } from './components/Imagine';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31bs0ncsq4vm6">
      <main data-id="element-1" data-mp="2wka02pum4x1q">
        <Hero data-id="element-2" data-mp="2wjqhd6x524mn" />
        <Letter data-id="element-3" data-mp="2wiyv4mpflj91" />
        <SevenDays data-id="element-4" data-mp="2wifbn1k4umsw" />
        <Bonuses data-id="element-5" data-mp="2wi5n7ieqknpb" />
        <ForYou data-id="element-6" data-mp="28u5y0mx2p5cu" />
        <Method data-id="element-7" data-mp="28tw972nrl48q" />
        <Pricing data-id="element-8" data-mp="28te4dhn1dhp7" />
        <Imagine data-id="element-9" data-mp="28surifc8tji1" />
      </main>
      <Footer data-id="element-10" data-mp="23vciyq2516ak" />
      <StickyBar data-id="element-11" data-mp="23vktwcepa1j4" />
    </div>;
}